import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import close from './close/close.js'
import form from './form/form.js'
import backdrop from './backdrop/backdrop.js'
import open from './open/open.js'

export default contract({
  backdrop: array([
    backdrop
  ]),
  close: array([
    close
  ]),
  form: array([
    form
  ]),
  open: array([
    open
  ]),
})